/**
 * Cart Minimum Order Value
 *
 * Blocks reaching checkout - NOT adding to cart - whenever the cart's
 * product value is under MIN_SUBTOTAL_CENTS. Shows a message and disables
 * the checkout button on both the cart drawer and the /cart page.
 *
 * Deliberately does not touch /cart/add in any way: the previous minimum
 * order value rule (in the BoomGate app) was scoped per-product instead
 * of per-cart, so it rejected individual in-stock products at add-to-cart
 * time with a 422 that looked like a false "out of stock" error. This
 * script only gates the checkout button itself, once the real cart total
 * is known, so a low subtotal can never surface as a stock problem.
 *
 * The SGR deposit lines (SKU containing "SGR") are excluded from the value
 * checked against the minimum: the rule is about product value, and the
 * deposit is refundable, not merchandise.
 *
 * Runs site-wide (included from layout/theme.liquid, same as
 * bundle-gift-guard.js) because the cart drawer can open from any page,
 * not just /cart. Re-evaluates on the theme's cart-update event and on a
 * fixed poll, since Dawn's own AJAX section re-renders replace the
 * checkout button element entirely (losing any state set on the old one).
 */
(function () {
  var MIN_SUBTOTAL_CENTS = 5000; // 50.00 RON
  var MIN_LABEL = '50 de lei';
  var MESSAGE_CLASS = 'cart-min-value-message';
  var POLL_MS = 2000;
  var DEBOUNCE_MS = 300;
  var CART_URL = '/cart.js';

  var debounceTimer = null;

  function scheduleCheck() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runCheck, DEBOUNCE_MS);
  }

  function runCheck() {
    fetch(CART_URL)
      .then(function (response) {
        return response.json();
      })
      .then(applyGate)
      .catch(function () {});
  }

  function isSgrLine(item) {
    var sku = (item.sku || '').toUpperCase();
    var handle = (item.handle || '').toLowerCase();
    return sku.indexOf('SGR') !== -1 || handle.indexOf('sgr') !== -1;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' Lei';
  }

  function messageHtml(missingCents) {
    return (
      '<span>Valoarea minimă a produselor trebuie să fie de ' + MIN_LABEL + '. ' +
      'Mai adaugă produse de încă <strong>' + formatMoney(missingCents) + '</strong> ' +
      'pentru a putea finaliza comanda.</span>'
    );
  }

  function buildMessageEl() {
    var el = document.createElement('div');
    el.className = MESSAGE_CLASS;
    el.setAttribute('role', 'alert');
    return el;
  }

  // Accelerated/dynamic checkout buttons (Shop Pay, PayPal, etc.) bypass
  // our own <button> entirely, so they need to be hidden separately -
  // disabling #checkout alone would not stop them.
  function gateDynamicButtons(container, belowMinimum) {
    if (!container) return;
    var dynamicButtons = container.querySelector('.cart__dynamic-checkout-buttons');
    if (!dynamicButtons) return;
    dynamicButtons.style.display = belowMinimum ? 'none' : '';
  }

  function gateButton(button, belowMinimum, missingCents, showMessage) {
    if (!button) return;
    var ctaContainer = button.closest('.cart__ctas') || button.parentElement;
    var footer = button.closest('.cart-drawer__footer, .cart__footer') || ctaContainer;
    var existingMessage = footer.querySelector('.' + MESSAGE_CLASS);

    if (belowMinimum) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.dataset.minValueDisabled = 'true';
      if (showMessage) {
        if (!existingMessage) {
          existingMessage = buildMessageEl();
          ctaContainer.insertBefore(existingMessage, button.parentElement === ctaContainer ? button : ctaContainer.firstChild);
        }
        var html = messageHtml(missingCents);
        if (existingMessage.innerHTML !== html) existingMessage.innerHTML = html;
      } else if (existingMessage) {
        existingMessage.remove();
      }
    } else {
      // Only re-enable if we were the ones who disabled it - leave the
      // theme's own empty-cart disabling (cart == empty) alone.
      if (button.dataset.minValueDisabled === 'true') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        delete button.dataset.minValueDisabled;
      }
      if (existingMessage) existingMessage.remove();
    }

    gateDynamicButtons(footer, belowMinimum);
  }

  function applyGate(cart) {
    if (!cart) return;

    var sgrTotal = 0;
    var productCount = 0;
    (cart.items || []).forEach(function (item) {
      if (isSgrLine(item)) {
        sgrTotal += item.final_line_price;
      } else {
        productCount += item.quantity;
      }
    });

    var productsTotal = cart.total_price - sgrTotal;
    var belowMinimum = productCount > 0 && productsTotal < MIN_SUBTOTAL_CENTS;
    var missingCents = Math.max(0, MIN_SUBTOTAL_CENTS - productsTotal);

    gateButton(document.querySelector('#checkout'), belowMinimum, missingCents, true);
    // The cart drawer renders its own notice at the top (snippets/cart-drawer.liquid),
    // in place of the free shipping bar - here we only gate its button.
    gateButton(document.querySelector('#CartDrawer-Checkout'), belowMinimum, missingCents, false);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      scheduleCheck();
    });
  }

  // Safety net: poll on a fixed interval regardless of any event system,
  // mirroring bundle-gift-guard.js's approach for the same reasons (the
  // Samita Order Limits app hooks into the same event bus and there's no
  // guarantee the theme's own cart-update event always fires cleanly).
  setInterval(scheduleCheck, POLL_MS);

  document.addEventListener('DOMContentLoaded', scheduleCheck);
})();
